<template>
  <div>
    <template v-if="annotationSubmitted">
      <div class="alert alert-success">
        Thank you for the annotation!
      </div>
    </template>
    <vue-editor id="editor" v-model="content" :editorToolbar="customToolbar"></vue-editor>
    <button v-if="!annotationSubmitted" id="save-button" type="button" class="btn btn-primary" @click="saveContent">Save</button>
  </div>
</template>


<script>
import { VueEditor } from 'vue2-editor'
import { db } from '@/main';
import firebase from 'firebase/app';

export default {

  components: {
    VueEditor
  },
  props: ['text', 'range'],
  data() {
    return {
      content: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['code-block']
      ],
      annotationSubmitted: false
    }
  },
  mounted() {
    this.annotationSubmitted = false;
  },
  methods: {
    saveContent() {
      var textLines = [];
      textLines.push(this.range[0].parentNode.id);
      for (var i=0; i < this.range.length; i++){
        if (this.range[i].nodeType === 1) {
          textLines.push(this.range[i].id)
        }
      }
      var annotationData = {
        annotationText: this.content,
        textToBeAnnotated: this.text,
        userId: firebase.auth().currentUser.uid,
        divIds: textLines,
        upVotes: [firebase.auth().currentUser.uid],
        downVotes: [],
      };
      db.collection('paperAnnotations').doc(this.$route.params.paperid).collection('annotations').add(annotationData
      ).then(() => {
        this.annotationSubmitted = true;
        this.$emit('annotationCreate', annotationData)
      })
      mixpanel.track("click", {"name": "save annotation button"})
    }
  }
}
</script>

<style>
#editor {
  height: 45vh;
}

#save-button {
  margin-top: 30px;
}
</style>